export enum PackagesTabEnum {
  INDIVIDUAL,
  COMPANIES,
}
